import { createFileRoute } from '@tanstack/react-router'

import { UserPaymentMethods } from '#/common/invoices-and-payments/user-payment-methods.tsx'
import { PermissionChecker } from '#/components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/payment-methods/')({
  component: () => (
    <PermissionChecker requiredPermissions={['paymentAccount.update']}>
      <UserPaymentMethods variant="client-portal" />
    </PermissionChecker>
  ),
})
